import { Loader2, StickyNote } from 'lucide-react';
import { useApprenantNotes } from '../hooks/useApprenantNotes.js';
import { AddNoteForm } from '../components/AddNoteForm.js';
import { NoteRow } from '../components/NoteRow.js';
import { useMe } from '../../../lib/useMe.js';

interface Props {
  apprenantId: string;
}

/**
 * Slice autonome — Notes apprenant (historique + ajout).
 * Réutilisable : à intégrer dans la fiche apprenant ET dans la page
 * Communications (vue filtrée par apprenant).
 */
export function NotesPanel({ apprenantId }: Props) {
  const { user } = useMe();
  const { data: notes, isLoading } = useApprenantNotes(apprenantId);

  return (
    <section className="rounded-xl border border-neutral-200 bg-white">
      <header className="flex items-center gap-2 border-b border-neutral-200 px-4 py-3">
        <StickyNote className="h-4 w-4 text-amber-500" />
        <h3 className="text-sm font-bold text-neutral-900">Notes internes</h3>
        {notes && (
          <span className="ml-auto rounded-full bg-neutral-100 px-2 py-0.5 text-[10px] font-semibold text-neutral-600">
            {notes.length}
          </span>
        )}
      </header>

      <div className="border-b border-neutral-200 bg-neutral-50/50 p-3">
        <AddNoteForm apprenantId={apprenantId} compact />
      </div>

      <div className="space-y-2 p-3">
        {isLoading && (
          <div className="flex items-center gap-2 py-4 text-xs text-neutral-500">
            <Loader2 className="h-3 w-3 animate-spin" />
            Chargement des notes…
          </div>
        )}
        {!isLoading && (!notes || notes.length === 0) && (
          <div className="py-4 text-center text-xs italic text-neutral-500">
            Aucune note pour l'instant. Ajoute la première ci-dessus.
          </div>
        )}
        {notes?.map((note) => (
          <NoteRow
            key={note.id}
            note={note}
            apprenantId={apprenantId}
            currentUserEmail={user?.email ?? null}
          />
        ))}
      </div>
    </section>
  );
}
